// FUNCTIONS
const renderSliderInitial = () => {
	document.querySelectorAll('.content-culture input[class^="photo-"]').forEach((element) => {
		if (!element.classList.contains('photo-1')) {
			imageArray.push(element.value);
		}
	});

	preloadImages(imageArray);
	splide = new Splide('#splide-productions').mount();
};

const updateCultureBlockCopy = () => {
	const expertise = document.querySelector('.expertise-' + currentNumber).value;
	const image = document.querySelector('.photo-' + currentNumber).value;
	const name = document.querySelector('.name-' + currentNumber).value;
	const paragraph = '"' + document.querySelector('.quote-' + currentNumber).value + '"';

	document.querySelector('.content-culture .copy-box .name').textContent = name;
	document.querySelector('.content-culture .copy-box .position .expertise').textContent = expertise;
	document.querySelector('.content-culture .copy-box img').src = image;
	document.querySelector('.content-culture .copy-box p').textContent = paragraph;

	document.querySelector('.current-number').textContent = leftPad(currentNumber, 2);
};

// VARIABLES
const maxNumber = parseInt(document.querySelector('.max-number').textContent);
const sliderControls = document.querySelector('.carousel menu');

let currentNumber = parseInt(document.querySelector('.current-number').textContent);
let imageArray = new Array;
let splide;

Splide.defaults = {
	arrows: false,
	autoplay: true,
	fixedHeight: 714,
	keyboard: false,
	lazyLoad: 'nearby',
	paginationKeyboard: false,
	pauseOnHover: true
}

// INITIALIZATION
renderSliderInitial();

// EVENT LISTENERS
sliderControls.addEventListener('click', (event) => {
	if (event.target.closest('.carousel menu li')) {
		const selectedMenuItem = event.target;

		if (!selectedMenuItem.classList.contains('active')) {
			const currentClass = document.querySelector('.carousel menu li.active').classList[0];
			const selectedClass = selectedMenuItem.className;

			document.querySelector('.carousel aside.active').classList.remove('active');
			document.querySelector('.carousel menu li.active').classList.remove('active');

			splide.destroy();
			document.getElementById('splide-' + currentClass).style.display = 'none';

			document.querySelector('.carousel aside[class*="' + selectedClass + '"]').classList.add('active');
			selectedMenuItem.classList.add('active');

			document.getElementById('splide-' + selectedClass).style.display = 'block';
			splide = new Splide('#splide-' + selectedClass).mount();
		}
	}
});

document.querySelector('.controls .next').addEventListener('click', () => {
	if (currentNumber == maxNumber) {
		currentNumber = 1;
	} else {
		currentNumber++;
	}

	updateCultureBlockCopy();
});

document.querySelector('.controls .prev').addEventListener('click', () => {
	if (currentNumber == 1) {
		currentNumber = maxNumber;
	} else {
		currentNumber--;
	}

	updateCultureBlockCopy();
});